import Flickity from "flickity";

const flickityOpts = {
  contain: true,
  imagesLoaded: true,
  pageDots: true,
  prevNextButtons: false,
  setGallerySize: false
};

const peekingScale = 0.8;
const focusSpeed = 2;

//////////////////////////////////////////////////
///////// HEIGHT ANIMATION CALCULAITIONS //////////
//////////////////////////////////////////////////

// Cards grow while being dragged instead of after they settle.
function updateFocus(flickity, cardHeight) {
  const position = -flickity.x;
  const targets = flickity.slides.map((slide) => slide.target);
  let from = flickity.selectedIndex;
  const step = position > targets[from] ? 1 : -1;
  let to = from + step;

  // A long drag can cross whole slides before Flickity reselects on release.
  while (to in targets && (targets[to] - position) * step < 0) {
    from = to;
    to += step;
  }

  const gap = targets[to] - targets[from];
  const progress = gap ? (position - targets[from]) / gap : 0;

  flickity.slides.forEach((slide, index) => {
    let focus = 0;
    if (index === from) {focus = 1 - progress;}
    if (index === to) {focus = progress;}

    // Reach full size halfway through the slide so the CTA and bottom border don't lag behind the settle.
    focus = Math.min(1, focus * focusSpeed);
    slide.cells.forEach(({ element }) => {
      element.style.height = `${cardHeight * (peekingScale + (1 - peekingScale) * focus)}px`;

      const $ctaWrapper = element.querySelector(".product-category__cta-wrapper");
      if (!$ctaWrapper) {return;}

      $ctaWrapper.style.gridTemplateRows = `${focus}fr`;
      $ctaWrapper.style.visibility = focus ? "visible" : "hidden";
    });
  });
}

// Measure the tallest card at its natural height with the CTA open and scale the others down from that.
function measureCardHeight(flickity) {
  const $cards = flickity.getCellElements();
  $cards.forEach(($card) => {
    $card.style.height = "";

    const $ctaWrapper = $card.querySelector(".product-category__cta-wrapper");
    if ($ctaWrapper) {$ctaWrapper.style.gridTemplateRows = "1fr";}
  });

  const cardHeight = Math.max(...$cards.map(($card) => $card.offsetHeight));
  flickity.viewport.style.height = `${cardHeight}px`;
  return cardHeight;
}

//////////////////////////////////////////////////
/////// END HEIGHT ANIMATION CALCULAITIONS ///////
//////////////////////////////////////////////////

function createCarousel($carousel) {
  if (Flickity.data($carousel)) {return;}

  const flickity = new Flickity($carousel, flickityOpts);
  let cardHeight = 0;

  // Fires every frame the slider moves: drag, settle, select and resize.
  flickity.on("scroll", () => updateFocus(flickity, cardHeight));

  flickity.on("resize", () => {
    cardHeight = measureCardHeight(flickity);
    updateFocus(flickity, cardHeight);
  });

  flickity.resize();

  // Peeking cards hide their CTA, so a tap on one brings it into focus instead.
  flickity.on("staticClick", (event, pointer, cellElement, cellIndex) => {
    if (cellElement && cellIndex !== flickity.selectedIndex) {flickity.select(cellIndex);}
  });
}

function destroyCarousel($carousel) {
  const flickity = Flickity.data($carousel);
  if (!flickity) {return;}

  // destroy() leaves the inline styles written by updateFocus and measureCardHeight behind.
  flickity.getCellElements().forEach(($card) => {
    $card.style.height = "";

    const $ctaWrapper = $card.querySelector(".product-category__cta-wrapper");
    if (!$ctaWrapper) {return;}

    $ctaWrapper.style.gridTemplateRows = "";
    $ctaWrapper.style.visibility = "";
  });

  flickity.viewport.style.height = "";
  flickity.destroy();
}

function productCategories() {
  const phoneQuery = window.matchMedia("(max-width: 767px)");

  function sync() {
    document.querySelectorAll(".js-product-categories-carousel").forEach(($carousel) => {
      if (phoneQuery.matches) {
        createCarousel($carousel);
      } else {
        destroyCarousel($carousel);
      }
    });
  }

  function onBlockSelect(e) {
    const $carousel = e.target.closest(".js-product-categories-carousel");
    const flickity = $carousel && Flickity.data($carousel);
    if (!flickity) {return;}

    const cellIndex = flickity.cells.findIndex((cell) => cell.element === e.target);
    if (cellIndex !== -1) {flickity.select(cellIndex);}
  }

  sync();
  phoneQuery.addEventListener("change", sync);

  // The theme editor swaps in fresh section markup on every setting change.
  if (window.Shopify?.designMode) {
    document.addEventListener("shopify:section:load", sync);
    document.addEventListener("shopify:block:select", onBlockSelect);
  }
}

export default productCategories;
